export default {
  LIST_POSTS: 'posts/gift/list',
  LIST_POSTS_NEXT: 'posts/list/next',
}
